module.exports = __webpack_public_path__ + "img/logo-UMMC.2a0b0f4b.svg";